/**
 * Added to sections and hold the id for the shadow box created by IvarShadowBoxSystem
 */
class IvarShadowBoxComponent {
    constructor(shadowBoxId) {
        this.typeId = IvarShadowBoxComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.shadowBoxId = shadowBoxId;
    }
    eq(other) {
        return this.shadowBoxId === other.shadowBoxId;
    }
}
IvarShadowBoxComponent.id = 2070;
export default IvarShadowBoxComponent;
//# sourceMappingURL=IvarShadowBoxComponent.js.map